export default "__VITE_ASSET__AwVBa8Nr__"